import { ElementRef, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { IsMobileService } from '../isMobile.service';
var DatePickerComponent = /** @class */ (function () {
    function DatePickerComponent(ngControl, isMobileService, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.pickerVisible = false;
        this.disabled = false;
        this.value = null;
        this.isMobile = isMobileService.isMobile;
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    DatePickerComponent.prototype.offClick = function (event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.pickerVisible = false;
        }
    };
    DatePickerComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(DatePickerComponent.prototype, "maxDateIso", {
        /**
         * El input nativo de móvil (type="date") espera el atributo "max" en ISO
         * (yyyy-MM-dd), no en el 'dd-MM-yyyy' que maneja el resto del componente.
         */
        get: function () {
            if ((undefined === this.maxDate) || (null === this.maxDate) || ('' === this.maxDate)) {
                return null;
            }
            var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
            return this.maxDate.replace(pattern, '$3-$2-$1');
        },
        enumerable: true,
        configurable: true
    });
    DatePickerComponent.prototype.writeValue = function (value) {
        this.parseValue(value);
    };
    DatePickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    DatePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DatePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    DatePickerComponent.prototype.onChange = function (event) {
    };
    DatePickerComponent.prototype.onTouched = function () { };
    DatePickerComponent.prototype.parseValue = function (selected) {
        if (!selected) {
            this.value = null;
        }
        else if (typeof selected === 'string') {
            this.value = selected;
        }
        else {
            this.value = this.addLeadingZero(selected.getDate()) + "-" + this.addLeadingZero(selected.getMonth() + 1) + "-" + selected.getFullYear();
        }
    };
    DatePickerComponent.prototype.onChangeMobile = function (selected) {
        if ((selected !== undefined) && (selected !== null) && (selected !== '')) {
            var pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
            this.onChange(selected.replace(pattern, '$3-$2-$1'));
        }
        if (selected === "") {
            this.onChange(null);
        }
    };
    DatePickerComponent.prototype.onSelectCallback = function (selected) {
        this.parseValue(selected);
        this.onChange(this.value);
        this.pickerVisible = true;
    };
    DatePickerComponent.prototype.onFocusOut = function (value) {
    };
    DatePickerComponent.prototype.addLeadingZero = function (value) {
        if (value < 10) {
            return "0" + value.toString();
        }
        return value.toString();
    };
    return DatePickerComponent;
}());
export { DatePickerComponent };
